import { render, staticRenderFns } from "./organChartPop.vue?vue&type=template&id=1da4192a"
import script from "./organChartPop.vue?vue&type=script&lang=js"
export * from "./organChartPop.vue?vue&type=script&lang=js"
import style0 from "./organChartPop.vue?vue&type=style&index=0&id=1da4192a&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports